import i18next, { type i18n } from 'i18next'
import { initReactI18next } from 'react-i18next'
import { DEFAULT_LANGUAGE, type Language } from './language'
import { NAMESPACES, resources } from './resources'

export interface CreateI18nOptions {
  language?: Language
  /** Called for every key missing from the bundle; tests turn this into a failure. */
  onMissingKey?: (language: string | undefined, namespace: string, key: string) => void
}

/** One instance per app — never the i18next singleton, so tests stay isolated. */
export function createI18n(options: CreateI18nOptions = {}): i18n {
  const { onMissingKey } = options
  const instance = i18next.createInstance()
  void instance.use(initReactI18next).init({
    resources,
    lng: options.language ?? DEFAULT_LANGUAGE,
    fallbackLng: DEFAULT_LANGUAGE,
    ns: [...NAMESPACES],
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    saveMissing: Boolean(onMissingKey),
    missingKeyHandler: onMissingKey
      ? (languages, namespace, key) => onMissingKey(languages[0], namespace, key)
      : undefined,
  })
  return instance
}
